module.exports = __webpack_public_path__ + "img/tem21.97942012.png";